import { Enum } from "./Enum";

export const CourierEnum: Enum[] = [
  { id: 'own_account', name: 'Own Account' },
  { id: 'fedex', name: 'Fedex' },
  { id: 'dhl', name: 'DHL' },
  { id: 'ups', name: 'UPS' },
  { id: 'usps', name: 'USPS' },
];